import LzdAjax from '@/utils/lzd-ajax';
import { dataFillCurrInfo } from '@/utils/lzd-util';

export interface TenantTeacherProp {
  seq?: number;
  teacherSeq: number;
  propId: string;
  propValue: string;
}

export async function queryTeacherProps(): Promise<TenantTeacherProp[]> {
  const res = await LzdAjax.post<TenantTeacherProp[]>(
    '/bsl/tenant/teacher/prop/query/list',
    dataFillCurrInfo({})
  );
  return res.code === 0 ? (res.data ?? []) : Promise.reject(res);
}

export async function saveTeacherProp(propId: string, propValue: string) {
  const res = await LzdAjax.post<TenantTeacherProp>(
    '/bsl/tenant/teacher/prop/save',
    dataFillCurrInfo({ propId, propValue })
  );
  return res.code === 0 ? res.data! : Promise.reject(res);
}
